import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=34e39e40&scoped=true"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"
import style0 from "./contact.vue?vue&type=style&index=0&id=34e39e40&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e39e40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\mam\\home\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34e39e40')) {
      api.createRecord('34e39e40', component.options)
    } else {
      api.reload('34e39e40', component.options)
    }
    module.hot.accept("./contact.vue?vue&type=template&id=34e39e40&scoped=true", function () {
      api.rerender('34e39e40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contact.vue"
export default component.exports